import React from "react";
import Header from "../common/Header";
import Footer from "../common/Footer";

const TermsAndConditions = () => {
  return (
    <>
      <Header />
      <div className="min-h-screen pt-24 pb-12 px-6 bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100 transition-colors duration-300">
        <div className="container mx-auto max-w-4xl">
          <h1 className="text-4xl font-bold mb-8 text-center text-green-600 dark:text-green-400">
            Terms & Conditions
          </h1>
          <div className="bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-lg border border-gray-100 dark:border-gray-700">
            <p className="text-lg text-gray-600 dark:text-gray-300">
              These are the Terms & Conditions...
            </p>
            {/* Placeholder for future content */}
            <div className="mt-4 h-64 bg-gray-100 dark:bg-gray-700/50 rounded-lg animate-pulse"></div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TermsAndConditions;
